/** Caché cliente de respuestas del copiloto (ISSUE-05 F4). */

const CACHE_KEY = "tagnize_copilot_response_cache";

export const SUGGESTION_QUERIES = [
  "¿Cuánto gastamos con DE LA ORDEN este mes?",
  "Facturas con CAE vencido o observadas",
  "Resumen financiero de los últimos 30 días",
  "Top proveedores por importe",
];

const TTL_SUGGESTION_MS = 15 * 60 * 1000;
const TTL_MONTHLY_MS = 60 * 60 * 1000;
const TTL_DOCUMENT_MS = 24 * 60 * 60 * 1000;
const TTL_GENERIC_MS = 5 * 60 * 1000;

export function normalizeQuery(message) {
  return (message || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
}

function monthBucket() {
  return new Date().toISOString().slice(0, 7);
}

function hashParts(parts) {
  const str = parts.join("|");
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0;
  }
  return `c_${Math.abs(h)}`;
}

export function buildCacheKey(tenantId, message, model) {
  return hashParts([
    tenantId || "default",
    normalizeQuery(message),
    model || "haiku",
    monthBucket(),
  ]);
}

function isSuggestionQuery(message) {
  const n = normalizeQuery(message);
  return SUGGESTION_QUERIES.some((q) => normalizeQuery(q) === n);
}

function isMonthlyQuery(message) {
  const n = normalizeQuery(message);
  return (
    /\beste mes\b/.test(n) ||
    /\b(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)\b/.test(n) ||
    /\búltimos?\s+\d+\s+días\b/.test(n) ||
    /\bresumen financiero\b/.test(n)
  );
}

function isDocumentQuery(message) {
  return /\b(a-?\d{4}-?\d{5,}|factura\s+[a-z0-9-]+)\b/i.test(message || "");
}

export function getCacheTtlMs(message) {
  if (isSuggestionQuery(message)) return TTL_SUGGESTION_MS;
  if (isDocumentQuery(message)) return TTL_DOCUMENT_MS;
  if (isMonthlyQuery(message)) return TTL_MONTHLY_MS;
  return TTL_GENERIC_MS;
}

function loadCache() {
  try {
    return JSON.parse(sessionStorage.getItem(CACHE_KEY) || "{}");
  } catch {
    return {};
  }
}

function saveCache(data) {
  sessionStorage.setItem(CACHE_KEY, JSON.stringify(data));
}

/** Solo primera pregunta de una sesión vacía (AC-F4.3). */
export function canUseCache(messages) {
  return !messages || messages.length === 0;
}

export function getCachedResponse(tenantId, message, model) {
  const key = buildCacheKey(tenantId, message, model);
  const entry = loadCache()[key];
  if (!entry) return null;
  if (Date.now() > entry.expiresAt) {
    const all = loadCache();
    delete all[key];
    saveCache(all);
    return null;
  }
  return entry.payload;
}

export function setCachedResponse(tenantId, message, model, payload) {
  const key = buildCacheKey(tenantId, message, model);
  const all = loadCache();
  all[key] = {
    payload,
    expiresAt: Date.now() + getCacheTtlMs(message),
    tenantId: tenantId || "default",
  };
  saveCache(all);
}

export function invalidateCache(tenantId) {
  const prefix = tenantId || "default";
  const all = loadCache();
  let changed = false;
  Object.keys(all).forEach((key) => {
    if (all[key]?.tenantId === prefix) {
      delete all[key];
      changed = true;
    }
  });
  if (changed) saveCache(all);
}
